import { Component, OnInit } from '@angular/core';
import { ApplicationDataService } from '../../../../services/application.service';
import { Document } from '../../../models/document';
import { LabelValue } from 'app/models/labelvalue';
import { Router } from '@angular/router';
import { AnalyticsService } from 'services/analytics.service';
import { ErrorService } from 'services/error.service';
import { finalize } from 'rxjs/internal/operators/finalize';

@Component({
  selector: 'app-documents-upload',
  templateUrl: './documents-upload.component.html',
  styleUrls: ['./documents-upload.component.css']
})
export class DocumentsUploadComponent implements OnInit {
  uploadedFiles: any[] = [];
  documents: Document[] = [];
  documentTypes: LabelValue[] = [];
  errorMessage: string;
  RentalApplication: boolean;
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  hasRentableItems: boolean;
  totalApplicationSteps: number = 8;
  disableSubmitBtn: boolean = false;
  currentApplicationStep: number = 5;
  verifastEnabled: boolean;
  isUploading:boolean=false;

  constructor(
    private applicationService: ApplicationDataService,
    private router: Router,
    private errorService: ErrorService,
    private readonly analyticsService: AnalyticsService) {
    this.analyticsService.track(
      'HRA Application',
      'Documents upload',
      'Start',
      'Start',
      '',
      this.additionalAnalyticsDetails());
    const applicationKey = localStorage.getItem('RentalApplicationKey');

    const AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    const AddAdditionalApplicantName = localStorage.getItem('AddAdditionalApplicantName');
    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantKey = Number(AddAdditionalApplicantKey);
    }

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.AddAdditionalApplicantName = AddAdditionalApplicantName
    }

    if (applicationKey && applicationKey.length > 0) {
      this.RentalApplication = true;
    }
  }

  private additionalAnalyticsDetails(): any {
    try {
      return {
        'Documents': this.documents?.map(x =>
          {
            return {
              'Type': x.Category
            };
          }) ?? []
      };
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const verifastEnabled = localStorage.getItem('verifastEnabled');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps = 9;
    }

    if (verifastEnabled && verifastEnabled === 'true') {
      this.verifastEnabled = true;
      this.totalApplicationSteps++;
      this.currentApplicationStep++;
    }

    this.getFiles();
    this.getDocumentTypes();
  }

  doDocumentsHaveDocumentTypes(){
    for (let i=0;i<this.documents.length;i++){
      if(this.documents[i].Category==null)
        return false;
    }
    return true;
  }
  isDocumentOutdated(uploadDateString: string) {
    const fileUploadDate: Date = new Date(uploadDateString);
    const cutoffDate: Date = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - 30);
    return fileUploadDate < cutoffDate;
  }

  onUpload(event) {
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.analyticsService.track(
      'HRA Application',
      'Documents upload',
      'Stop',
      'Cancelling edit',
      '/application/applicants',
      this.additionalAnalyticsDetails());
    this.router.navigate(['/application/applicants']);
  }


  uploadFiles(event) {
    this.analyticsService.track(
      'HRA Application',
      'Documents upload',
      'Document dialog - Open',
      'opening the document dialog',
      '',
      this.additionalAnalyticsDetails());
    this.isUploading=true;  
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      var index;
      const formData: FormData = new FormData();
      for (index = 0; index < fileList.length; index++) {
        const file: File = fileList[index];
        formData.append('uploadFile' + index, file, file.name);
      }
      this.applicationService.uploadApplicantDocument(formData, this.AddAdditionalApplicantKey)
        .subscribe(res => this.onFileUploadSuccess(), err =>{ 
          this.isUploading=false;
          this.errorMessage = this.applicationService.handleError(err);});
    }
  }

  getFiles() {
    this.applicationService.getApplicantDocuments(this.AddAdditionalApplicantKey)
      .pipe(finalize(()=>{this.isUploading=false}))
      .subscribe(res => this.documents = res, res => this.errorMessage = this.applicationService.handleError(res));

  }

  onFileUploadSuccess() {
    this.analyticsService.track(
      'HRA Application',
      'Documents upload',
      'Document dialog - Close',
      'The document upload is complete',
      '',
      this.additionalAnalyticsDetails());
    this.getFiles();
  }

  getDocumentTypes() {
    this.applicationService.getDocumentTypes()
      .subscribe(res => this.documentTypes = res, err => this.applicationService.handleError(err));
  }

  onDocChange(document: Document) {
    this.applicationService.updateApplicantDocument(document, this.AddAdditionalApplicantKey)
      .subscribe(res => this.onDocUpdateSuccess(res), err => this.errorMessage = this.applicationService.handleError(err));
  }

  onDocUpdateSuccess(document: Document) { }

  onDocDelete(document: Document) {
    this.applicationService.deleteApplicantDocument(this.AddAdditionalApplicantKey, document)
      .subscribe(res => this.getFiles(), err => this.errorMessage = this.applicationService.handleError(err));
  }

  onContinueClick() {
    if (this.doDocumentsHaveDocumentTypes()==false){
      this.errorService.showError(`All documents must be assigned a Document Type!`);
      return;
    }

    if (this.RentalApplication) {
      this.analyticsService.track(
        'HRA Application',
        'Documents upload',
        'Stop',
        'Sending to background check',
        '/application/background-check',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/background-check']);
    } else {
      this.analyticsService.track(
        'HRA Application',
        'Documents upload',
        'Stop',
        'Not a rental application',
        '/application/dashboard',
        this.additionalAnalyticsDetails());
      this.router.navigate(['/application/dashboard']);
    }
  }

}
